function fn_part_ui_wsw() {
    var $fn = $(".part_ui_wsw");

    if ($fn.length) {
        $fn.find("table").each(function() {
            $(this).wrap("<div class='elm_wsw_table'></div>");
        });
    }
}